import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";
import { endpoint } from "../../../utils/constants/endpoint";
import { PURGE } from "redux-persist";
import { toast } from "react-toastify";

const _initialState = {
  status: "idle", // idle, pending, done
  isLoading: false,
};

export const doUserRegistration = createAsyncThunk(
  "registration/user",
  async (body, thunkAPI) => {
    const response = await client.post(
      endpoint.USERS.GUEST_REGISTER_LITE,
      body
    );
    if (response.ok) {
      return thunkAPI.fulfillWithValue(response.data);
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const doAdminRegistration = createAsyncThunk(
  "registration/admin",
  async (body, thunkAPI) => {
    const response = await client.post(
      endpoint.ADMIN_ACCOUNT.GUEST_REGISTER_COMMERCIALISTA_RESP,
      body
    );
    if (response.ok) {
      return thunkAPI.fulfillWithValue(response.data);
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

const registrationSlice = createSlice({
  name: "registration",
  initialState: _initialState,
  reducers: {
    resetRegistrationLoading: (state) => {
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doUserRegistration.pending, (state) => {
        state.status = "pending";
        state.isLoading = true;
      })
      .addCase(doUserRegistration.fulfilled, (state, action) => {
        if (
          action.payload.Result === 13 &&
          action.payload.StringResult === "EmailTaken"
        ) {
          state.status = "idle";
          toast.error("Questa email è già stata usata");
        } else if (action.payload.Result === 1) {
          state.status = "done";
        }
        state.isLoading = false;
      })
      .addCase(doUserRegistration.rejected, (state, action) => {
        state.status = "idle";
        state.isLoading = false;
      })

      .addCase(doAdminRegistration.pending, (state) => {
        state.status = "pending";
        state.isLoading = true;
      })
      .addCase(doAdminRegistration.fulfilled, (state, action) => {
        if (
          action.payload.Result === 13 &&
          action.payload.StringResult === "EmailTaken"
        ) {
          toast.error("Questa email è già stata usata");
          state.status = "idle";
        } else if (
          action.payload.Data === true &&
          action.payload.Result === 1
        ) {
          state.status = "done";
        }
        state.isLoading = false;
      })
      .addCase(doAdminRegistration.rejected, (state, action) => {
        state.status = "idle";
        state.isLoading = false;
      })

      .addCase(PURGE, (state) => {
        state = _initialState;
        return state;
      });
  },
});

export const { name, reducer, actions } = registrationSlice;
